export const AREA_SUBSCRIPTION_MODAL_ID = 'area-subscription-modal';
export const AREA_SUBSCRIPTION_LOADED_EVENT = 'area-subscription::loaded';
